








import { Component, Prop, Vue } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import MentoringRequestList from '../../requestslist';
import { REQUEST_WARNING } from '@/pages/profile/modules';
import { IMentoringRejectedRequests, Requests } from './types';

@Component({
  components: {
    Warning,
    MentoringRequestList,
  },
})
export default class MentoringRejectedRequests
  extends Vue
  implements IMentoringRejectedRequests {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Requests;

  warningText: string = REQUEST_WARNING;

  get rejectedItems(): Requests {
    // Здесь фильтруем по отклоненным запросам
    return this.items.filter((item) => item.status === '4');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/rejectedrequests/MentoringRejectedRequests.vue